import type { LandingDict } from './en';

const de: LandingDict = {
  nav: { chat: 'Chat Apps', agentic: 'Agentic Apps', build: "App erstellen", org: "My Org", pricing: 'Preise', privacy: "Datenschutz", contact: "Kontakt", language: 'Sprache' },
  hero: {
    titlePre: 'Dein lokales\n',
    titleMark: 'KI-Kraftwerk.',
    titlePost: '',
    sub: "Machen Sie aus Expertenwissen, Tabellen und Meetings Antworten, Diagramme und Präsentationen. Nichts verlässt Ihren Mac.",
    watch: "2-Minuten-Film ansehen",
    pill: "Neueste Version",
    chip: "WLAN aus · 0 Bytes gesendet",
    badges: { offline: "Funktioniert offline", server: "Ihr Server, nicht unserer", free: "Kostenlos starten" },
    reqs: 'Erfordert einen Mac mit Apple Silicon · mindestens 16 GB Arbeitsspeicher · ab 32 GB laufen die größeren empfohlenen Modelle',
  },
  stats: {
    free: 'Kostenlos',
    freeSub: 'Alle Chat Apps, Modelldownloads und Updates – für immer',
    chatApps: 'Chat Apps',
    agenticApps: 'Agentic Apps',
    bytesSub: 'Bytes gehen in die Cloud, wenn die KI auf diesem Mac läuft',
    langsSub: 'Sprachen für die Oberfläche, von Deutsch bis 日本語',
  },
  film: { kicker: 'Der Film', title: 'Estha in Aktion.', watchOnYouTube: 'Auf YouTube ansehen', trouble: 'Probleme bei der Wiedergabe? Auf YouTube ansehen ↗' },
  overview: {
    kicker: 'Eine App, vier Arten zu arbeiten',
    title: 'Vom Chat zum Agenten.\nBis zur App fürs ganze Team.',
    explore: 'Entdecken',
    chat: { title: 'Chat Apps', desc: 'KI-Experten, fundiert durch kuratierte Wissensdatenbanken – Lehrbücher, Leitfäden und Fachwissen.', tag: 'Immer kostenlos' },
    agentic: { title: 'Agentic Apps', desc: 'Aufgabenorientierte KI-Agenten, die komplexe Arbeiten von Anfang bis Ende erledigen.', tag: '{n} und es werden mehr' },
    build: { title: "App erstellen", desc: 'Mach mit Quick Bot aus deinen eigenen Unterlagen eine Chat App – oder stell auf dem Playground-Canvas eigene Abläufe zusammen.', tag: 'Quick Bot · Playground' },
    org: { title: 'My Org', desc: 'Der eigene App-Bereich deiner Organisation – im eigenen Branding, mit geprüften Apps und kontrolliertem Zugriff.', tag: 'Enterprise' },
  },
  chat: {
    kicker: 'Chat Apps',
    title: 'Experten-KI mit echtem Fachwissen.',
    freePill: 'Immer kostenlos',
    lede: 'Jede Chat App bringt ihre eigene Wissensdatenbank mit – direkt auf deinem Mac indexiert.',
    feats: {
      kb: { title: 'Lokale Wissensdatenbanken', desc: 'Bei der Installation entsteht die Wissensdatenbank lokal – die Antworten stammen aus kuratiertem Material.' },
      files: { title: 'Deine eigenen Dateien', desc: 'Hänge Bilder, PDF, DOCX, TXT oder MD an – bei langen Dokumenten greift die intelligente Suche.' },
      browse: { title: 'Stöbern, anheften, merken', desc: 'Kategorien von Assessment bis Karriere, NEW-Tags für neue Apps und ⌘K, um alles zu durchsuchen.' },
    },
  },
  agentic: {
    kicker: 'Agentic Apps',
    title: '{n} Agentic Apps.\nUnd es werden mehr.',
    lede: 'Aus einer Tabelle, einem PDF, einer Aufnahme oder einer Idee wird ein fertiges Diagramm, eine Präsentation, ein Dokument oder ein Prototyp – privat auf deinem Mac.',
    seeThem: 'Sieh sie dir in Aktion an',
  },
  build: {
    kicker: 'App erstellen',
    title: 'Deine eigene Chat App.\nDirekt auf deinem Mac.',
    lede: 'Mach aus deinen eigenen Dateien eine Chat App – lokal indexiert und veröffentlicht, wenn du so weit bist.',
    quick: {
      badge: 'Empfohlen',
      desc: 'Lade eine Wissensdatenbank hoch, schreibe einen System-Prompt und veröffentliche. Ideal, um Materialien schnell in einen Frage-Antwort-Bot zu verwandeln.',
      items: ['Einseitiges Formular, in wenigen Schritten erledigt', 'Wissensdatenbank-Q&A sofort einsatzbereit', 'Integrierte Prompt-Vorlagen als Inspiration'],
    },
    advanced: {
      title: 'Erweitert · Playground',
      desc: 'Visueller Node-Editor, um mehrere Nodes, Verzweigungen, AB-Tests und Keyword-Routing frei zusammenzustellen.',
      items: ['Node-Canvas', 'Mehrere Nodes / Verzweigung / AB-Test', 'Feingranulare Felder & Debugging'],
    },
    guideTitle: 'Ein lokaler KI-Bauassistent an deiner Seite.',
    guideText: 'Sag ihm, was deine App können soll, und er zeigt dir, welche Nodes du ziehst und wie du sie verbindest. Das Erstellen ist in Premium enthalten.',
  },
  private: {
    kicker: 'Privat von Grund auf',
    title: "Keine Cloud für Ihre Daten.\nKein Tracking Ihrer Arbeit.",
    lede: "Sie entscheiden, wo die KI läuft. Estha wählt standardmäßig für jede Funktion das passende Modell — und Sie können jederzeit in der App wechseln.",
    boundary: "Datengrenze = Ihr Netzwerk",
    local: { title: 'Auf diesem Mac', desc: 'Vollständig offline, nichts verlässt dieses Gerät. Nutzt den Speicher dieses Computers.', best: 'Ideal für Macs mit reichlich Arbeitsspeicher' },
    server: { title: 'Auf meinem Estha Server', desc: 'Lagere die schwere Arbeit auf einen leistungsstärkeren Mac im Netzwerk aus und halte diesen Mac leicht.', best: 'Ideal für Laptops und Macs mit wenig Arbeitsspeicher' },
    cluster: { desc: 'Verbinde dich mit einem Mac Studio Cluster, um rechenintensive Inferenz auszulagern – deine Daten bleiben dabei im eigenen Haus.', best: 'Findet Estha-Studio-Master-Knoten in deinem Netzwerk automatisch' },
    models: {
      every: 'Läuft auf jedem unterstützten Mac',
      whisper: "Whisper für die Transkription",
      recommended: 'Die empfohlenen Modelle',
      larger: "Größere Qwen- und Gemma-Modelle",
      vision: "Vision-Modelle für Bilder",
      open: 'Offene Modelle, optimiert für Apple Silicon',
      openItems: ['Modelle direkt in der App laden und wechseln', 'Eigene Modelle für Code und Embeddings', 'Modelldownloads immer kostenlos'],
    },
  },
  org: {
    kicker: 'My Org',
    title: 'Ein eigener KI-App-Bereich für deine Organisation.',
    lede: 'Ein Bereich in Estha im Branding deiner Organisation – mit den Apps, die sie für ihre Leute geprüft hat.',
    signIn: 'Bei My Org Admin anmelden',
    talk: 'Sprich mit dem Estha-Team',
    feats: {
      review: { title: 'Prüfung vor Veröffentlichung', desc: 'Jede neue App, jedes Update und jede Entfernung geht zuerst an einen Admin. Ablehnungen kommen immer mit schriftlicher Begründung.' },
      access: { title: 'Zugriff nach Gruppe oder Person', desc: 'Leg genau fest, wer welche App sieht – nach Abteilung, Team oder Person.' },
      brand: { title: 'Deine Marke in der App', desc: 'Name, Begrüßung, Logo, Banner und Akzentfarbe deiner Organisation – mit Vorschau, bevor alles live geht.' },
    },
  },
  pricing: {
    kicker: 'Mitgliedschaft',
    title: 'Starte kostenlos. Schalte alles frei, wenn du so weit bist.',
    free: { name: 'Kostenlos', sub: 'Für immer kostenlos.', items: ["Alle Chat Apps", 'Dokumentenverarbeitung, für immer kostenlos', 'Modelldownloads, Software und Updates — immer kostenlos'] },
    premium: {
      name: 'Premium', flag: '14 Tage kostenlos testen', firstYear: 'im ersten Jahr',
      sub: 'Danach $30/Jahr. Bestätige deine E-Mail-Adresse und teste 14 Tage kostenlos.',
      items: ['Alles aus Kostenlos', 'Alle aktuellen und zukünftigen Agentic Apps', 'Chat-App-Builder — lokale Chatbots erstellen, bearbeiten, testen, speichern und veröffentlichen'],
      cta: 'Test in der App starten',
    },
    enterprise: {
      name: 'Enterprise', price: 'Auf Anfrage', sub: 'Für Organisationen, die Estha in ihren Teams einführen.',
      items: ['Alles aus Premium', 'Individuelle Chat Apps und Agentic Apps für dein Team', 'Estha Server App-Funktion', 'My Org App-Bereich und My Org Admin'],
    },
  },
  faq: {
    title: 'Gut zu wissen,\nbevor du lädst.',
    spec: { chip: 'Chip', memory: 'Arbeitsspeicher', memMin: 'Mindestens 16 GB', memRec: '32 GB+ für die empfohlenen Modelle', languages: 'Sprachen', langsVal: '13 Sprachen für die Oberfläche', version: 'Neueste Version' },
    qa: [
      { q: 'Verlässt irgendetwas meinen Mac?', a: 'Wenn die KI auf diesem Mac läuft, arbeitet sie komplett offline – nichts verlässt das Gerät. Wählst du einen Estha Server oder einen Mac Studio Cluster, gehen die Daten nur an genau diesen Rechner in deinem eigenen Netzwerk.' },
      { q: "Wofür wird eine Internetverbindung benötigt?", a: "Nur für wenige Dinge: Anmeldung und E-Mail-Bestätigung für die Premium-Testversion, Modell-Downloads und die Suche nach Updates. Ihre Prompts, Dateien und Ergebnisse werden nie hochgeladen — sobald ein Modell geladen ist, arbeitet die KI vollständig offline." },
      { q: 'Was ist kostenlos, was ist Premium?', a: 'Alle Chat Apps, Dokumentenverarbeitung, Modelldownloads und Updates sind kostenlos. Premium schaltet alle aktuellen und zukünftigen Agentic Apps sowie den Chat-App-Builder frei – mit 14 Tagen kostenlosem Test.' },
      { q: 'Welche KI-Modelle nutzt Estha?', a: 'Führende Open-Source-Modelle wie Qwen und Gemma, dazu Whisper für die Transkription – ausgeführt über Apples MLX-Engine. Du lädst und wechselst sie direkt in der App.' },
      { q: 'Kann ich meine eigene App bauen?', a: 'Ja. Mit Quick Bot machst du aus bis zu drei Dateien in wenigen Schritten eine Chat App mit Wissensdatenbank. Oder du nutzt den Node-Canvas im Playground für Verzweigungen, AB-Tests und Quizze. Ein lokaler Bauassistent hilft dir dabei.' },
      { q: 'Wie führen Organisationen Estha ein?', a: 'Mit Enterprise verwalten Admins Nutzer und Gruppen in My Org Admin und prüfen jede App vor der Veröffentlichung. Mitglieder bekommen in Estha einen eigenen My Org Bereich im Branding ihrer Organisation. Kontakt: {email}.' },
    ],
  },
  final: { title: 'Bereit für KI, die lokal läuft?', reqs: 'Läuft auf jedem Mac mit Apple Silicon · mindestens 16 GB RAM' },
  footer: {
    tagline: 'Dein lokales KI-Kraftwerk – auf dem Gerät, angetrieben von MLX, privat von Grund auf.',
    product: 'Produkt', createApp: 'App erstellen', pricing: 'Preise',
    orgs: "My Org", signIn: 'Bei My Org Admin anmelden',
    security: "Sicherheit", changelog: "Änderungsprotokoll", docs: "Dokumentation", support: "Support",
    company: 'Unternehmen', privacy: 'Datenschutzerklärung', terms: 'Nutzungsbedingungen',
    rights: '© 2026 Estha. Alle Rechte vorbehalten.',
  },
  proof: { press: "Bekannt aus", voices: "Was Teams sagen" },
  contact: {
    title: "E-Mail an das Estha-Team", copy: "E-Mail-Adresse kopieren", copied: "Kopiert",
    gmail: "In Gmail schreiben", mailApp: "In der Mail-App öffnen",
    subject: "Anfrage zu Estha for Mac",
  },
  share: {
    button: "Teilen", title: "Estha teilen",
    sub: "Wähle eine Karte und poste sie – oder schick einfach den Link.",
    style: "Karte", size: "Format",
    templates: { hero: "Estha", agentic: "Agentic Apps", private: "Privat" },
    landscape: "Querformat", portrait: "Hochformat",
    shareImage: "Bild teilen …", download: "Bild herunterladen", copyImage: "Bild kopieren", copied: "Kopiert",
    copyLink: "Link kopieren", link: "Link", postTo: "Teilen auf",
    email: "E-Mail",
    text: "Estha führt Open-Source-KI-Modelle komplett auf deinem Mac aus – privat, offline und kostenlos.",
    cardCta: "Kostenloser Download für Macs mit Apple Silicon",
    close: "Schließen",
  },
  apps: {
    dataAnalyst: { name: 'Datenanalyst', description: 'Laden Sie CSV-/Excel-Dateien hoch und stellen Sie Fragen in natürlicher Sprache. Generiert automatisch Diagramme, statistische Analysen und Daten-Einblicke – alles lokal auf Ihrem Mac verarbeitet.', tags: ['CSV / Excel', 'Automatische Diagramme', 'Abfrage in natürlicher Sprache', 'EN / 中文'] },
    pptMaker: { name: 'PPT Maker', description: 'Beschreiben Sie Ihr Präsentationsthema und erhalten Sie ein professionell strukturiertes PowerPoint-Deck. Eine mehrstufige KI-Pipeline generiert Gliederung, Inhalte pro Folie und eine ausgefeilte .pptx-Datei.', tags: ['.pptx-Ausgabe', 'Automatisches Layout', 'Mehrstufige Pipeline'] },
    pdfReader: { name: 'PDF-Reader', description: 'Öffnen Sie ein PDF und stellen Sie Fragen dazu. Jede Antwort stützt sich auf das Dokument, mit klickbaren Zitaten, die direkt zur Quellstelle springen — alles lokal auf Ihrem Mac.', tags: ['PDF-Fragen', 'Prüfbare Zitate', 'Auswahl fragen', '100 % lokal'] },
    documentProcessing: { name: 'Dokumentenverarbeitung', description: 'Ihr Allround-Dokumentexperte. Entwerfen Sie Blogbeiträge, Social-Media-Texte, Rechtsklauseln und Geschäftsdokumente von Grund auf. Bearbeiten und optimieren Sie bestehende Dateien, übersetzen Sie zwischen Sprachen und prüfen Sie Inhalte auf Qualität – alles privat auf Ihrem Mac.', tags: ['Entwurf & Schreiben', 'Bearbeitung & Optimierung', 'Übersetzung', 'Prüfung & Audit'] },
    meetingIntelligence: { name: 'Meeting Intelligence', description: 'Zeichnen Sie Meetings mit KI auf, transkribieren und analysieren Sie sie. Generieren Sie automatisch Besprechungsprotokolle, Aufgaben und wichtige Entscheidungen – mit vollständiger Privatsphäre, kein Audio verlässt jemals Ihr Gerät.', tags: ['Transkription', 'Besprechungsprotokoll', 'Aufgaben', '100 % privat'] },
    vibeCoding: { name: 'Vibe Coding: Prototyp', description: 'Erstellen Sie interaktive Vorschauen mit KI. Beschreiben Sie eine Oberfläche in natürlicher Sprache, erhalten Sie einen klickbaren Prototyp und verfeinern Sie ihn weiter. Erzeugt eine einzige eigenständige .html-Datei, vollständig lokal auf Ihrem Mac.', tags: ['Einzelne .html-Datei', 'Interaktive Vorschau', 'Per Klick bearbeiten', '100 % lokal'] },
    translate: { name: "Übersetzen", description: "Übersetzen Sie Text sowie Word-, Text- oder Markdown-Dokumente mit einem gemeinsamen Glossar, das Ihre Begriffe konsistent hält – alles lokal auf Ihrem Mac.", tags: ["Text & Dokumente", ".docx / .txt / .md", "Glossar", "100 % lokal"] },
  },
  screens: {
    chat: [
      { label: 'Store durchstöbern', caption: 'Stöbern, installieren, anheften – immer kostenlos' },
      { label: 'Installieren', caption: 'Die Wissensdatenbank entsteht bei der Installation lokal' },
      { label: 'Fragen', caption: 'Antworten auf Basis ihres Leitfadens' },
    ],
    build: [
      { label: 'App erstellen', caption: 'Quick Bot oder Erweitert – beide sofort chatbereit' },
      { label: 'Quick Bot', caption: 'Wissensdatenbank hochladen. Prompt schreiben. Veröffentlichen.' },
      { label: 'Playground', caption: 'Nodes, Verzweigungen und Wissen – visuell' },
      { label: 'Veröffentlicht', caption: 'Veröffentlicht und bereit zum Chatten' },
    ],
    analyst: [
      { label: 'Frage stellen', caption: 'Frag deine Daten in natürlicher Sprache' },
      { label: 'Analyse läuft', caption: 'Analysiert auf deinem Mac' },
      { label: 'Diagramm & Erkenntnis', caption: 'Die Antwort, das Diagramm und der Weg dorthin' },
    ],
    ppt: [
      { label: 'Einrichten', caption: 'Thema, Folien, Sprache, Tonalität, Design' },
      { label: 'Gliederung prüfen', caption: 'Bearbeite die Gliederung, bevor etwas generiert wird' },
      { label: 'Vorschau', caption: 'Eine fertige, bearbeitbare .pptx – auf deinem Mac' },
    ],
    pdf: [
      { label: 'PDF öffnen', caption: 'Paper, Berichte, Handbücher und Scans' },
      { label: 'Wird gelesen', caption: 'Lokal gelesen, Seite für Seite' },
      { label: 'Antwort mit Quelle', caption: 'Jede Antwort zeigt auf die exakte Stelle' },
    ],
    doc: [
      { label: 'Passage markieren', caption: 'Text markieren und sagen, was du willst' },
      { label: 'Wird umgeschrieben', caption: 'Direkt im Dokument umgeschrieben' },
      { label: 'Annehmen oder ablehnen', caption: 'Umschreiben, feilen, übersetzen – annehmen oder ablehnen' },
    ],
    meeting: [
      { label: 'Aufnehmen', caption: 'Live-Transkript, auf diesem Mac' },
      { label: 'Ausgaben wählen', caption: 'Wähl aus, was erstellt werden soll' },
      { label: 'Zusammenfassung', caption: 'Entscheidungen und Aufgaben, für dich formuliert' },
      { label: 'Aufgaben', caption: 'Verantwortliche und Fristen, mit Belegen' },
    ],
    vibe: [
      { label: 'Beschreiben', caption: 'Beschreib eine Oberfläche in natürlicher Sprache' },
      { label: 'Wird generiert', caption: 'Komplett auf diesem Mac gebaut' },
      { label: 'Prototyp', caption: 'Klickbar, versioniert, eine .html-Datei' },
      { label: 'Per Klick bearbeiten', caption: 'Wähl einen Bereich und sag, was sich ändern soll' },
    ],
    translate: [
      { label: "Text übersetzen", caption: "Violette Wörter stammen aus Ihrem Glossar" },
      { label: "Dokument übersetzen", caption: ".docx, .txt oder .md – das Original bleibt unverändert" },
      { label: "Glossar", caption: "Ihr Glossar hält jeden Begriff konsistent" },
    ],
    private: [
      { label: 'Auf diesem Mac', caption: 'Komplett offline. Nichts verlässt dieses Gerät.' },
      { label: 'Mac Studio Cluster', caption: 'Größere Modelle – im eigenen Haus' },
    ],
    org: [
      { label: 'Org-App-Bereich', caption: 'Eigenes Branding, Apps fürs Team' },
      { label: 'Enterprise-Plan', caption: 'Mitglieder öffnen nur freigegebene Apps' },
    ],
  },
};

export default de;
